import React from 'react'
import injectSheet from 'react-jss'
import styles from './shared-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import { BulkCheckbox } from 'pobble-components/dist/bulk-action'
import ContextMenu from './context-menu/context-menu.container'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

const SharedEntry = ({
  classes,
  received,
  from,
  title,
  lo,
  id,
  pending,
  previewLink,
  seen
}) => (
  <TableRow pending={pending}>
    <Cell
      center
      className={classNames(classes.checkboxChell, {
        [classes.unseen]: !seen
      })}>
      <BulkCheckbox id={id} />
    </Cell>
    <Cell className={classes.date}>{received}</Cell>
    <Cell>
      <strong>{from}</strong>
    </Cell>
    <Cell>
      <Link className={classes.previewLink} to={previewLink}>
        {title}
      </Link>
    </Cell>
    <Cell>{lo}</Cell>
    <Cell right>
      <ContextMenu id={id} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(SharedEntry)
